import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-clock-icon/jb-clock-icon.css.ts
var jb_clock_icon_css_default = i`svg{opacity:var(--jb-clock-opacity, 0.7)}`;

export {
  jb_clock_icon_css_default
};
